// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tcpG","top":"styles_top__2ZoWb"};